import { ButtonSecondary, IconThumbsUp } from '@americanexpress/dls-react';
import LiteralsService from 'src/services/literals/LiteralsService';
import React from 'react';
import Selectors from 'src/utils/selectors';

interface Props {
    transactionName: string;
    onClick?: () => void;
    withText?: boolean;
    className?: string;
}

export default function ApproveTransactionButton({
    transactionName,
    withText,
    className,
    onClick
}: Props): JSX.Element {
    return (
        <ButtonSecondary
            className={className}
            onClick={onClick}
            data-cy={Selectors.SpendSmart.APPROVE_BUTTON}
            icon={<IconThumbsUp />}
            aria-label={`${LiteralsService.getLiteral('TransactionsTable.approve')} ${transactionName}`}
        >
            {withText && LiteralsService.getLiteral('TransactionsTable.approve')}
        </ButtonSecondary>
    );
}
